export type CasinoLobbyPreset = {
  searchInput: string;
  providerIds: string[];
  categoryIds: string[];
};

const STORAGE_KEY = 'casinoLobbyPreset:v1';
const EVENT_NAME = 'casinoLobbyPreset';
const eventTarget = new EventTarget();

export const setCasinoLobbyPreset = (preset: CasinoLobbyPreset): void => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(preset));
  } catch {}

  try {
    eventTarget.dispatchEvent(new CustomEvent<CasinoLobbyPreset>(EVENT_NAME, { detail: preset }));
  } catch {}
};

export const consumeCasinoLobbyPreset = (): CasinoLobbyPreset | null => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(STORAGE_KEY);
    const parsed = JSON.parse(raw) as CasinoLobbyPreset;
    if (!parsed || typeof parsed !== 'object') return null;
    return {
      searchInput: typeof parsed.searchInput === 'string' ? parsed.searchInput : '',
      providerIds: Array.isArray(parsed.providerIds) ? parsed.providerIds.filter(Boolean) : [],
      categoryIds: Array.isArray(parsed.categoryIds) ? parsed.categoryIds.filter(Boolean) : [],
    };
  } catch {
    return null;
  }
};

export const subscribeCasinoLobbyPreset = (handler: (preset: CasinoLobbyPreset) => void): (() => void) => {
  const listener = (event: Event) => {
    const preset = (event as CustomEvent<CasinoLobbyPreset>).detail;
    if (!preset) return;
    handler(preset);
  };

  eventTarget.addEventListener(EVENT_NAME, listener);
  return () => eventTarget.removeEventListener(EVENT_NAME, listener);
};

